export const getOrderStatus = (status = '') => {
    switch(status) {
        case 'pending':
            return 'Новый';

        case 'payment_pending':
            return 'Обработка';

        case 'completed':
            return 'Выполнен';

        case 'failed':
            return 'Произошла ошибка';

        case 'refunded':
            return 'Возвращено';

        case 'new':
            return 'Новый'

        case 'in_job':
            return 'В работе'

        case 'success':
            return 'Выполнен'

        case 'cancelled':
            return 'Отменён'

        case 'processing':
            return 'В работе'

        case 'paid':
            return 'Заказ оплачен'


        default:
            return status;
    }
}